import { render, staticRenderFns } from "./OrderAddressCustom.vue?vue&type=template&id=2b2142ac&"
import script from "./OrderAddressCustom.vue?vue&type=script&lang=ts&"
export * from "./OrderAddressCustom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports